/* eslint-disable react/prop-types */
import { DataGrid } from 'devextreme-react';
import {
  Column,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
} from 'devextreme-react/data-grid';
import React, { useState } from 'react';
import { FormGroup, Input } from 'reactstrap';
import {
  gridModuloEmpresaDataSource,
  handleUpdateModuloEmpres,
} from '~/pages/Modulos/ModulosServices';
import { Container } from './styles';

function Lista({ setLoading, loading }) {
  const [pageIndex, setPageIndex] = useState(null);
  const [pageSize, setPageSize] = useState(15);

  function handleOptionChange(event) {
    if (event.fullName === 'paging.pageSize' && event.value !== pageSize) {
      setPageSize(event.value);
      setPageIndex(0);
    }

    setPageIndex(null);
  }

  const applyFilterTypes = [
    {
      key: 'auto',
      name: 'Immediately',
    },
    {
      key: 'onClick',
      name: 'On Button Click',
    },
  ];

  const filterOptions = {
    showFilterRow: true,
    showHeaderFilter: true,
    currentFilter: applyFilterTypes[0].key,
  };

  const checkRender = (e) => (
    <FormGroup
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Input
        disabled={loading}
        type="checkbox"
        defaultChecked={e.data.check}
        onChange={() => {
          handleUpdateModuloEmpres(
            !e.data.check,
            e.data.id,
            e.data.idPessoa,
            e,
            setLoading
          );
        }}
      />
    </FormGroup>
  );

  return (
    <Container>
      <h1>Empresa </h1>

      <DataGrid
        dataSource={gridModuloEmpresaDataSource}
        remoteOperations
        showBorders
        allowColumnReordering
        allowColumnResizing
        columnAutoWidth
        onOptionChanged={handleOptionChange}
      >
        <Pager
          visible
          showPageSizeSelector
          allowedPageSizes={[7, 10, 15]}
          showInfo
        />
        <Paging defaultPageSize={pageSize} pageIndex={pageIndex} />
        <FilterRow
          visible={filterOptions.showFilterRow}
          applyFilter={filterOptions.currentFilter}
        />
        <Column
          dataField="idPessoa"
          caption="Id"
          alignment="left"
          filterOperations
          allowSearch
        >
          <HeaderFilter groupInterval={100} />
        </Column>
        <Column
          alignment="left"
          dataField="nome"
          caption="Nome da empresa"
          filterOperations
          allowSearch
        >
          <HeaderFilter groupInterval={100} />
        </Column>
        <Column
          alignment="center"
          dataField="check"
          caption="Vincular?"
          editCellRender={checkRender}
        />
      </DataGrid>
    </Container>
  );
}

export default Lista;
